module.exports = __webpack_public_path__ + "static/media/hero_img.a71477f1.png";